// Split the 1003 employment rows into what the W-2 salary rules can run and what they
// cannot. Past jobs (is_current false) never count toward qualifying income.
export function splitBakeoffIncome(employment) {
  let w2Monthly = 0;
  let otherMonthly = 0;
  let otherRows = 0;
  (employment || []).forEach((e) => {
    if (e.is_current === false) return;
    const monthly = Number(e.monthly_gross) || 0;
    if (e.is_self_employed || e.other_income_type) {
      otherMonthly += monthly;
      if (monthly > 0) otherRows += 1;
    } else {
      w2Monthly += monthly;
    }
  });
  return { monthlyIncome: w2Monthly, annualBase: w2Monthly * 12, otherMonthly, otherRows };
}
